
function _getBreadcrumb(treeData, targetNodeId) {
  // 递归函数，用于查找目标节点及其路径
  function findNode(node, path = []) {
    // 如果当前节点匹配目标节点，则返回当前路径
    if (node.id === targetNodeId) {
      return [...path, node];
    }

    // 如果当前节点有子节点，则继续递归查找
    if (node.children && node.children.length > 0) {
      for (const child of node.children) {
        const result = findNode(child, [...path, node]);
        if (result) {
          return result;
        }
      }
    }

    // 如果当前节点不匹配目标节点且没有子节点，则返回空
    return null;
  }

  // 在树型数据中查找目标节点及其路径
  for (const node of treeData) {
    const result = findNode(node);
    if (result) {
      return result;
    }
  }

  // 如果未找到目标节点，则返回空数组
  return [];
}

function getBreadcrumbById(state) {
  return (targetNodeId) => {
    return _getBreadcrumb(state.menu.menuList, targetNodeId)
  }
}
const getters = {

  isShowHeaderAndFooter: state => state.global.isShowHeaderAndFooter,
  token: state => state.user.token,
  getBreadcrumbById
}
export default getters
